import { render, staticRenderFns } from "./DetailSociete.vue?vue&type=template&id=44520cc9&scoped=true"
import script from "./DetailSociete.vue?vue&type=script&lang=js"
export * from "./DetailSociete.vue?vue&type=script&lang=js"
import style0 from "./DetailSociete.vue?vue&type=style&index=0&id=44520cc9&prod&scoped=true&lang=css"
import style1 from "./DetailSociete.vue?vue&type=style&index=1&id=44520cc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_babel-core@7.0.0-bridge.0_@babel+core@7.29._a26fb9023b752f5df33ae8450879cd09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44520cc9",
  null
  
)

export default component.exports